import { css } from '@emotion/react'
import { zIndex } from '@mathflat/common/style'

const S = {
  // 카메라 레이어 위에 선다. 거절 안내도 같은 층이지만 나중에 붙어 그 위에 보인다
  dim: css`
    position: fixed;
    inset: 0;
    z-index: ${zIndex.ModalPortal};
    background: rgba(0, 0, 0, 0.5);
  `,

  // 학년을 접고 펴도 출렁이지 않게 높이를 고정하고, 넘치면 몸통만 스크롤한다
  modal: css`
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: ${zIndex.ModalPortal};
    display: flex;
    flex-direction: column;
    width: 600px;
    max-width: calc(100% - 32px);
    height: 540px;
    max-height: calc(100% - 32px);
    overflow: hidden;
    transform: translate(-50%, -50%);
    border-radius: var(--Radius-300);
    background: var(--White);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
    color: var(--Colors-Gray-900);
    word-break: keep-all;
  `,

  head: css`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 8px;
    height: 56px;
    padding: 0 16px;
    border-bottom: 1px solid var(--Colors-Gray-300);
  `,

  title: css`
    flex: 1;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
  `,

  close: css`
    display: inline-flex;
  `,

  body: css`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
  `,

  notice: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 64px 16px;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
  `,

  retry: css`
    padding: 8px 12px;
    font-size: 14px;
    line-height: 21px;
    color: var(--Colors-Sky-600);
    text-decoration: underline;
  `,

  footer: css`
    flex-shrink: 0;
    padding: 12px 16px;
    border-top: 1px solid var(--Colors-Gray-200);
  `,
}

export default S
